import type { Tone } from '../types/content';

export const reviewQueue: { title: string; meta: string; status: string; tone: Tone }[] = [
  { title: 'Sleep fragmentation → Working memory', meta: '3 sources', status: 'Awaiting review', tone: 'warn' },
  { title: 'Evening screen use → Sleep onset', meta: '5 sources', status: 'Awaiting review', tone: 'warn' },
  { title: 'Merge: cognitive load / mental workload', meta: 'Terminology', status: 'Curator', tone: 'accent' },
];

export const evidence: { source: string; detail: string; stance: string; tone: Tone }[] = [
  { source: 'Hendricks et al., 2023', detail: 'Results · p. 6', stance: 'Supports', tone: 'ok' },
  { source: 'Okafor & Lin, 2021', detail: 'Discussion · p. 11', stance: 'Supports', tone: 'ok' },
  { source: 'Varga et al., 2022', detail: 'Limitations · p. 9', stance: 'Qualifies', tone: 'warn' },
];

export const activity: { who: string; what: string; when: string }[] = [
  { who: 'R. Lindqvist', what: 'linked a passage to Working memory', when: '12m' },
  { who: 'Curation pipeline', what: 'proposed 4 relationships', when: '1h' },
  { who: 'M. Haddad', what: 'approved the term “sleep efficiency”', when: '3h' },
];

export const samplePassage = {
  source: 'Hendricks et al. (2023). Sleep fragmentation and working memory in adolescents.',
  journal: 'Journal of Sample Sleep Research · Sample record',
  location: 'Results · p. 6',
  before: 'Across the two-week protocol, ',
  highlight: 'participants with higher sleep fragmentation showed lower accuracy on working-memory tasks',
  after: ', an effect that persisted after adjusting for total sleep time and baseline attention scores.',
};

export const sampleRelationship = {
  from: 'Sleep fragmentation',
  relation: 'associated with reduced',
  to: 'Working memory',
  confidence: 'Moderate',
};
